var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon3NuLessons = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.846 10.984v8.86h.005C6.98 21.594 10.58 23 15 23c4.422 0 8.02-1.405 8.147-3.156h.009v-8.86H6.846z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.861c-3.347-1.828-8-3.215-12-5.488 0-.296.01-.59.032-.887 4.136-1.86 8.621-3.009 11.968-4.6 3.349 1.591 7.832 2.774 11.969 4.639.02.293.031.552.031.848-3.998 2.273-8.651 3.66-12 5.488z",
    fill: "#0A0B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.977c-3.347-1.832-8-3.217-12-5.49C7 10.214 11.653 8.826 15 7c3.349 1.827 7.97 3.25 11.969 5.525-4 2.273-8.62 3.62-11.969 5.452z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.186 17.754a.263.263 0 0 1-.262-.264v-1.557c0-.097.05-.184.133-.231l5.27-3.009a.262.262 0 0 1 .36.1.267.267 0 0 1-.099.36l-5.137 2.934v1.403a.264.264 0 0 1-.265.264z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18 17.49c-.385 0-.7.315-.7.705v3.931c0 .392.315.708.7.708a.705.705 0 0 0 .705-.708v-3.931a.705.705 0 0 0-.705-.705z",
    fill: "#FFF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon3NuLessons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-3nu-lessons.27c811ab552ca95f6f4d034b07a19777.svg";